// ----------------------------------------------------------------
	// READMORE
define('root/Assets/Templates/Html/ImageTexts/Js/ImageTexts',[
	'jquery'
], function(
	$
) {
	'use strict';

	$('.js_readmore').on('click', function(){

		var $this = $(this),
			$parent = $(this).closest('.js_readmore-parent'),
		 $moreContainer = $parent.find('.js_readmore_content'),
			moreContHeight = $moreContainer.outerHeight();
		var $linkText = $this;
		//var $linkIcon = $(this).children('.linkIcon');

		var $text = $linkText.children('span');
		var readmore = $linkText.data('readmore');
		var readless = $linkText.data('readless');

		if (!$moreContainer.hasClass('is_open')) {
			$moreContainer.removeAttr('style');
			//add height from container
			$moreContainer.css('max-height', '3600px');
			$moreContainer.addClass('is_open');


			$linkText.addClass('is_in_fade');
			//$linkIcon.addClass('is_open');

			setTimeout(function() {

				$linkText.addClass('is_open');
				$text.html(readless);
				$linkText.removeClass('is_in_fade');
			}, 250);

			setTimeout(function() {
				$('html, body').animate({
					scrollTop: $moreContainer.offset().top - 280
				}, 500);
			}, 500);

		} else {
			$moreContainer.removeAttr('style');
			$moreContainer.removeClass('is_open');
			$linkText.addClass('is_in_fade');
			//$linkIcon.removeClass('is_open');
			setTimeout(function() {
				$linkText.removeClass('is_open');
				$text.html(readmore);
				$linkText.removeClass('is_in_fade');
			}, 250);
		}
	});
});

